module.exports = __webpack_public_path__ + "static/media/2.434c9896.png";